import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;

export const TRACKING_ENDPOINT_PATH = "/utilities/track/";

function postAnalyticsTracking(data: any, oauthTokenHeader: string) {
  return fetchWrapper.post(
    `${apiUrl}${TRACKING_ENDPOINT_PATH}`,
    data,
    oauthTokenHeader
  );
}

export const trackingAnalyticsService = {
  postAnalyticsTracking,
};
